export function searchForm() {
    const body = document.getElementById('searchFrom');
    const openBtn = document.getElementById('searchFrom_open')
    const closeBtn = document.getElementById('searchFrom_close');
    const bg = document.getElementById('searchFrom_bg');
    const delay = 300;

    function open() {
        body.classList.add('open');
        bg.classList.add('open');

        setTimeout(function () {
            body.classList.add('opacity');
            bg.classList.add('opacity');
        })
    }

    function close() {
        body.classList.remove('opacity');
        bg.classList.remove('opacity');

        setTimeout(function () {
            body.classList.remove('open');
            bg.classList.remove('open');
        },delay)
    }

    if(body && openBtn) {
        openBtn.addEventListener('click',function () {
            open();
        })

        closeBtn.addEventListener('click',function () {
            close();
        })

        bg.addEventListener('click',function () {
            close();
        })
    }


}